const stage = 'prod';

export const getCurrentStage = (): string => {
    return stage;
};

export const envConfig = {
    Auth: {
        identityPoolId: 'us-west-2:5971b94d-3211-4c34-80f9-18f40825f704',
        region: 'us-west-2',
        userPoolId: 'us-west-2_9FGWU83UN',
        userPoolWebClientId: '5s8tvj4thd12khoq6m8fe3e4q7',
        mandatorySignIn: true,
        oauth: {
            domain: 'finspace-prod' + '.auth.us-west-2.amazoncognito.com',
            redirectSignIn: 'https://' + window.location.host + '/',
            redirectSignOut: 'https://' + window.location.host+ '/',
            scope: ['openid'],
            responseType: 'code',
        },
    },
    API: {
        endpoints: [
            {
                name: 'FinSpaceService',
                endpoint: `https://api.${stage}.service.finspace.finergy.amazon.dev`,
                region: 'us-west-2',
            },
        ],
    },
    Storage: {
        AWSS3: {
            bucket: `finspace-transfer-${stage}`,
            region: 'us-west-2',
        },
    },
};
